module.exports = __webpack_public_path__ + "static/media/loupsGarous_01_full.6287fa23.gif";